import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import Navbar from '../Navbar';
import '../App.css';
import '../RSVP.css';
import { useAuth } from '../auth.js';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const RSVPPage = () => {
  const [guests, setGuests] = useState([]);
  const [message, setMessage] = useState('');
  const { user, loading } = useAuth();
  const [firebaseMessage, setFirebaseMessage] = useState('');
  const [messageFeedback, setMessageFeedback] = useState('');
  const [adminGuests, setAdminGuests] = useState([]);
  const [adminMessages, setAdminMessages] = useState([]);

  const getBackgroundColor = (status) => {
    switch (status) {
      case 'Attending':
        return '#c8e6c9';
      case 'Not Attending':
        return '#ffccbc';
      case 'Unconfirmed':
        return '#ffe0b2';
      default:
        return '#ffffff';
    }
  };

  const foodCounts = {
    Beef: 0,
    Tuna: 0,
    'Gluten Free': 0,
    Vegan: 0,
    'No Preference': 0,
  };

  adminGuests.forEach((guest) => {
    if (foodCounts.hasOwnProperty(guest.food)) {
      foodCounts[guest.food]++;
    }
  });

  useEffect(() => {
    if (loading || !user) return;

    const fetchGuestAndMessageData = async () => {
      try {
        const userDocRef = doc(db, user.email, 'RSVP');
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const data = userDoc.data();
          const guestData = data.Guests || {};
          setMessage(data.Message || '');

          // Fetch food choices from separate document
          const foodDocRef = doc(db, user.email, 'Food');
          const foodDoc = await getDoc(foodDocRef);
          const foodData = foodDoc.exists() ? foodDoc.data().Guests || {} : {};

          // Merge RSVP and food into one array
          const guestList = Object.keys(guestData).map((name) => ({
            name,
            status: guestData[name],
            food: foodData[name] || 'None',
          }));

          const updatedGuestList = guestList.map((guest) => {
            if (guest.status === 'Not Attending' && guest.food !== 'N/A') {
              // Update Firestore for that guest's food choice
              updateFoodInFirestore(guest.name, 'N/A');
              return { ...guest, food: 'N/A' };
            }
            return guest;
          });

          setGuests(updatedGuestList);
        }
      } catch (error) {
        console.error('Error fetching guests, message, or food:', error);
      }
    };

    const fetchAllGuests = async () => {
      try {
        const userEmails = [
          'chloe.stefanie.dahl@gmail.com',
          'ocarbonneau@hotmail.com',
          'ddahl@shaw.ca',
          'awdahl38@gmail.com',
          'superen1@telus.net',
          'nolanhehr@hotmail.com',
          'jnjsrob@shaw.ca',
          'zoomer.17.sr@gmail.com',
          'jamier2b@gmail.com',
          'victoria.potter@mymhc.ca',
          'dmcmarti1992@gmail.com',
          'christodd137@gmail.com',
          'krawchukjonathan@gmail.com',
          'kristen@canyonstateit.com',
          'find.a.byron@gmail.com',
          'lauren.shanti.ang@gmail.com',
          'dylanjoycemail@gmail.com',
          'wang.peter91@gmail.com',
          'sglover445@gmail.com',
          'patrick.m.walkowski@gmail.com',
          'robynmogavero@gmail.com',
          'iansaari42@gmail.com',
          'dydanielkim@outlook.com',
          'cole.raschpichler@gmail.com',
          'gtfox@gtfox.com',
          'rthreff@gmail.com',
          'vmrsto@gmail.com',
          'a.schwabe@live.com',
          'lianne29_@hotmail.com',
          'benarowland@gmail.com',
          'lyne.c2@telus.net',
        ];

        let allGuests = [];
        let messages = [];

        for (const email of userEmails) {
          const rsvpDocRef = doc(db, email, 'RSVP');
          const rsvpDoc = await getDoc(rsvpDocRef);

          const foodDocRef = doc(db, email, 'Food');
          const foodDoc = await getDoc(foodDocRef);
          const foodData = foodDoc.exists() ? foodDoc.data().Guests || {} : {};

          if (rsvpDoc.exists()) {
            const rsvpData = rsvpDoc.data();
            const guestData = rsvpData.Guests || {};
            const guestList = Object.keys(guestData).map((name) => ({
              name,
              status: guestData[name],
              email,
              food: foodData[name] || 'No Preference',
            }));
            allGuests = allGuests.concat(guestList);

            if (rsvpData.Message) {
              messages.push({ email, message: rsvpData.Message });
            }
          }
        }

        setAdminGuests(allGuests);
        setAdminMessages(messages);
      } catch (error) {
        console.error('Error fetching all guests and messages:', error);
      }
    };

    if (user?.email === 'amanhehr@gmail.com') {
      fetchAllGuests();
    }

    fetchGuestAndMessageData();
  }, [user, loading]);

  const updateStatusInFirestore = async (guestName, newStatus) => {
    try {
      const userDocRef = doc(db, user.email, 'RSVP');
      await updateDoc(userDocRef, {
        [`Guests.${guestName}`]: newStatus,
      });
      setFirebaseMessage('Update Successful!');
    } catch (error) {
      console.error('Error updating RSVP status:', error);
      setFirebaseMessage('Update Failed - refresh and try again.');
    }
  };

  const updateFoodInFirestore = async (guestName, newFood) => {
    try {
      const foodDocRef = doc(db, user.email, 'Food');
      await updateDoc(foodDocRef, {
        [`Guests.${guestName}`]: newFood,
      });
      setFirebaseMessage('Meal choice updated!');
    } catch (error) {
      console.error('Error updating food choice:', error);
      setFirebaseMessage(
        'Failed to update meal choice. Refresh and try again.'
      );
    }
  };

  const handleStatusChange = (index, event) => {
    const newStatus = event.target.value;
    const updatedGuests = [...guests];
    const guestName = updatedGuests[index].name;
    updatedGuests[index].status = newStatus;

    // If status is Not Attending, set food to "N/A"
    if (newStatus === 'Not Attending') {
      updatedGuests[index].food = 'N/A';
      updateFoodInFirestore(guestName, 'N/A');
    }

    setGuests(updatedGuests);
    updateStatusInFirestore(guestName, newStatus);
  };

  const handleFoodChange = (index, event) => {
    const newFood = event.target.value;
    const updatedGuests = [...guests];
    const guestName = updatedGuests[index].name;
    updatedGuests[index].food = newFood;
    setGuests(updatedGuests);
    updateFoodInFirestore(guestName, newFood);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const saveMessageToFirestore = async () => {
    try {
      const userDocRef = doc(db, user.email, 'RSVP');
      await updateDoc(userDocRef, {
        Message: message,
      });
      setMessageFeedback('Message saved successfully!');
    } catch (error) {
      console.error('Error saving message:', error);
      setMessageFeedback('Error saving message - try again later.');
    }
  };

  if (loading) return <div>Loading...</div>;

  const groupedGuests = adminGuests.reduce((acc, guest) => {
    const { email, name, status } = guest;
    if (!acc[email]) acc[email] = [];
    acc[email].push({ name, status });
    return acc;
  }, {});

  const unconfirmedCount = adminGuests.filter(
    (guest) => guest.status === 'Unconfirmed'
  ).length;
  const attendingCount = adminGuests.filter(
    (guest) => guest.status === 'Attending'
  ).length;
  const notAttendingCount = adminGuests.filter(
    (guest) => guest.status === 'Not Attending'
  ).length;

  return (
    <div>
      <Navbar />
      <div className='main-content'>
        <div className='container'>
          <div className='col-8-lg padding-top'>
            <h1 className='mediumBrownFontColour'>RSVP</h1>
            <h2 className='mediumBrownFontColour'>by August 1, 2025</h2>
            <p>
              We are so excited to have you join us! Below you should see a list
              of all the guests in your invite, and the option to select each
              guest as Attending, Not Attending, or Unconfirmed. If this page
              isn’t working properly, please email us your RSVP info at
              amanhehr@gmail.com.
            </p>
            <p>
              Main course options:
              <ul>
                <li>
                  Seared sesame-crusted tuna medallion with sauteed asparagus,
                  mashed potatoes, and teriyaki sauce
                </li>
                <li>
                  Beef fillet with duck pate, baby potatoes, and red wine sauce
                  with a blend of mushrooms
                </li>
                <li>Gluten-free option (TBD)</li>
                <li>Vegan option (TBD)</li>
              </ul>
              See the full menu on the home page.
            </p>
          </div>
          <div className='col-8-lg'>
            <div className='table'>
              <div className='table-row table-header'>
                <div className='table-name'>Guest</div>
                <div className='table-status'>RSVP Status</div>
                <div className='table-food'>Meal Choice</div>
              </div>
              {guests.map((guest, index) => (
                <div
                  className='table-row'
                  key={index}
                  style={{ backgroundColor: getBackgroundColor(guest.status) }}
                >
                  <div className='table-name'>{guest.name}</div>
                  <div className='table-status'>
                    <select
                      value={guest.status || ''}
                      onChange={(event) => handleStatusChange(index, event)}
                      onClick={() => setFirebaseMessage('')}
                    >
                      <option value='Unconfirmed'>Unconfirmed</option>
                      <option value='Attending'>Attending</option>
                      <option value='Not Attending'>Not Attending</option>
                    </select>
                  </div>
                  <div className='table-food'>
                    {guest.status !== 'Not Attending' && (
                      <select
                        value={guest.food || 'No Preference'}
                        onChange={(event) => handleFoodChange(index, event)}
                        onClick={() => setFirebaseMessage('')}
                      >
                        <option value='No Preference'>No Preference</option>
                        <option value='Tuna'>Tuna</option>
                        <option value='Beef'>Beef</option>
                        <option value='Gluten Free'>Gluten Free</option>
                        <option value='Vegan'>Vegan</option>
                      </select>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className='firebase-message'>
              <span>{firebaseMessage || ''}</span>
            </div>
          </div>
        </div>
        <div className='brown-bg'>
          <div className='container'>
            <div className='col-8-lg'>
              <h2>Optional Details</h2>
              <p>
                Feel free to include your flight details, resort booking
                details, anything else you’d like us to know, or just send us a
                note! You can update this section at any time.
              </p>
              <textarea
                rows='4'
                cols='50'
                value={message}
                onChange={handleMessageChange}
                placeholder='Type your message here...'
                onClick={() => setMessageFeedback('')}
                style={{ width: '100%' }}
              />
              <button className='blueButton' onClick={saveMessageToFirestore}>
                Save
              </button>
              <div className='firebase-message'>
                <span>{messageFeedback || ''}</span>
              </div>
            </div>
          </div>
        </div>

        {user?.email === 'amanhehr@gmail.com' && (
          <div className='admin-rsvp-status'>
            <h2>All Guest RSVPs</h2>
            <div className='rsvp-status-columns'>
              <div className='column'>
                <h3>Unconfirmed ({unconfirmedCount})</h3>
              </div>
              <div className='column'>
                <h3>Attending ({attendingCount})</h3>
              </div>
              <div className='column'>
                <h3>Not Attending ({notAttendingCount})</h3>
              </div>
            </div>
            {Object.entries(groupedGuests).map(([email, guestsByEmail]) => (
              <div key={email} className='rsvp-status-email-group'>
                <div className='email-group-box'>
                  <h3 className='guest-email'>{email}</h3>
                  <div className='rsvp-status-columns'>
                    <div className='column'>
                      {guestsByEmail
                        .filter((guest) => guest.status === 'Unconfirmed')
                        .map((guest, index) => (
                          <p key={index} className='guest-status unconfirmed'>
                            {guest.name}
                          </p>
                        ))}
                    </div>
                    <div className='column'>
                      {guestsByEmail
                        .filter((guest) => guest.status === 'Attending')
                        .map((guest, index) => (
                          <p key={index} className='guest-status attending'>
                            {guest.name}
                          </p>
                        ))}
                    </div>
                    <div className='column'>
                      {guestsByEmail
                        .filter((guest) => guest.status === 'Not Attending')
                        .map((guest, index) => (
                          <p key={index} className='guest-status not-attending'>
                            {guest.name}
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <h2>Messages</h2>
            <div className='messages-section'>
              {adminMessages.length > 0 ? (
                adminMessages.map((entry, index) => (
                  <div key={index} className='message-entry'>
                    <p>
                      <strong>Email:</strong> {entry.email}
                    </p>
                    <p>
                      <strong>Message:</strong> {entry.message}
                    </p>
                  </div>
                ))
              ) : (
                <p>No messages available.</p>
              )}
            </div>
            <div className='admin-food-preference'>
              <h2>Guest Food Preferences</h2>
              <div className='table admin-food-table'>
                <div className='table-row table-header'>
                  <div className='table-name'>Guest</div>
                  <div className='table-food-choice'>
                    Beef ({foodCounts['Beef']})
                  </div>
                  <div className='table-food-choice'>
                    Tuna ({foodCounts['Tuna']})
                  </div>
                  <div className='table-food-choice'>
                    Gluten Free ({foodCounts['Gluten Free']})
                  </div>
                  <div className='table-food-choice'>
                    Vegan ({foodCounts['Vegan']})
                  </div>
                  <div className='table-food-choice'>
                    No Preference ({foodCounts['No Preference']})
                  </div>
                </div>
                {adminGuests.map((guest, index) => {
                  let rowColor = '#c8e6c9'; // default green
                  if (guest.food === 'No Preference') rowColor = '#fff9c4'; // yellow
                  if (guest.food === 'N/A') rowColor = '#e0e0e0'; // grey

                  return (
                    <div
                      key={index}
                      className='table-row'
                      style={{ backgroundColor: rowColor }}
                    >
                      <div className='table-name'>{guest.name}</div>
                      {[
                        'Beef',
                        'Tuna',
                        'Gluten Free',
                        'Vegan',
                        'No Preference',
                      ].map((option, idx) => (
                        <div className='table-food-choice' key={idx}>
                          {guest.food === option ? '✔' : ''}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RSVPPage;
